import * as i18next from 'i18next';

import { CellRenderer, MainColumns } from '../../../../../components/TableGrid';
import { BenchmarkCompanyView } from '../../../../../generated/model/benchmarkCompanyView';
import { BenchmarkInfo } from '../../../../../generated/model/benchmarkInfo';
import { SearchListColumns } from '../../../../FinancialData/Companies/SearchList';

export function CompaniesMatrixTableColumns(
  t: i18next.TFunction,
  onCellClicked: (data: BenchmarkCompanyView) => void,
) {
  // No need to pass benchmarkId for SearchListColumns function, because column that need it will not be used here
  const searchColumns = filterOutColumns(SearchListColumns(t, false));
  const benchmarkingColumns = [
    {
      headerName: `${t('benchmark:companyColumns:status')}`,
      field: 'benchmarkInfo.status',
      minWidth: 150,
      unSortIcon: true,
      valueFormatter: statusFormatter,
    },
    {
      headerName: `${t('benchmark:companyColumns:comment')}`,
      field: 'benchmarkInfo.comment',
      minWidth: 150,
      unSortIcon: true,
    },
    {
      headerName: `${t('companies:columns:companyName')}`,
      field: 'companyInfo.name',
      minWidth: 300,
      unSortIcon: true,
      cellRenderer: CellRenderer.Clickable,
      cellRendererParams: {
        valueIfEmpty: t('companies:unknown'),
        onClickHandler: onCellClicked,
      },
    },
  ];
  // hide the rest of searchColumns by default
  const columns = searchColumns
    .slice(2, searchColumns.length)
    .map((col) => ({ ...col, hide: true }));
  return [searchColumns[0], ...benchmarkingColumns, ...columns];
}

function filterOutColumns(columns: MainColumns[]): MainColumns[] {
  return columns.filter((col) => col.field !== 'companyInfo.topShareHolders');
}

function statusFormatter(params: any) {
  switch (params.value as BenchmarkInfo.StatusEnum) {
    case 'ACCEPTED': {
      return 'Accepted';
    }
    case 'REJECTED': {
      return 'Rejected';
    }
    case 'POSTPONED': {
      return 'Review later';
    }
  }
  return params.value;
}

export default CompaniesMatrixTableColumns;
